import { animate, style, transition, trigger } from '@angular/animations'
import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { RouterPreloader } from '@angular/router'
import { TranslateModule } from '@ngx-translate/core'
import { InlineSVGModule } from 'ng-inline-svg-2'
import { AppBaseComponent } from '../../shared/components/app-base.component'
import { AppNavbarItem } from '../../shared/models/interfaces/app-navbar-item.interface'
import { NavbarService } from './navbar.service'
import { AppRoutePreloadingStrategy } from '../../shared/services/app-route-preloading.strategy'

@Component({
   selector: 'navbar',
   templateUrl: './navbar.component.html',
   styleUrls: ['./navbar.component.scss'],
   animations: [
      trigger('inOut', [
         transition(':enter', [style({ transform: 'translateX(-100%)', opacity: 0 }), animate(500)]),
         transition(':leave', [style({ opacity: 0 }), animate(0, style({ width: 0 }))])
      ])
   ],
   standalone: true,
   imports: [CommonModule, InlineSVGModule, TranslateModule]
})
export class NavbarComponent extends AppBaseComponent {
   @Input() isSidebarOpen?: boolean | null

   public navBarItems$ = this.navbarService.sidebarItems$

   constructor(
      public navbarService: NavbarService,
      private routerPreloader: RouterPreloader,
      private routePreloadingStrategy: AppRoutePreloadingStrategy
   ) {
      super()
   }

   preloadItem(item: AppNavbarItem) {
      if (!item.id) return

      if (this.routePreloadingStrategy.requestGroup(item.id)) {
         this.routerPreloader.preload().subscribe()
      }
   }

   handleItemClick(item: AppNavbarItem) {
      if (item.subItems) {
         item.subItemsIsOpen = !item.subItemsIsOpen
      }
      item.goTo()
   }
}
